if (window.innerWidth < 750) {
    const engagementsSwiper = new Swiper(".engagements .swiper-container", {
        direction: 'horizontal',
        loop: false,
        pagination: {
          el: ".engagements .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".engagements .swiper-button-next",
          prevEl: ".engagements .swiper-button-prev",
        },
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 10
      });

}